import React from "react";
import {Label} from "lib/components";
import {useComponentContext } from "lib/components/Context";
import { getDataFromContext } from "lib/util/ModelUtil";
import { getLogger } from "lib/util";

const log = getLogger("designer.PropertyKeyLabel");

export function PropertyKeyLabel({content, selectedComponents, propertiesChanged}) {
    let context = useComponentContext();
    let data = getDataFromContext(context);
    let props;
    if (data.containsDefaultValue !== true)
      props = {fontBold: true, color: "rgb(0, 0, 200)"};
    return <Label caption={data.key} fontSize="small" {...props} />
}
